/* compliance.js — beachai.com cookie consent + GPC honoring
   - Self-contained, no external requests.
   - Reads navigator.globalPrivacyControl and forwards an opt-out
     to Shopify's customer_privacy API when available.
   - Records consent in localStorage + Shopify-recommended
     `Set-Customer-Privacy-Consent` cookie pattern.
   Created by compliance audit 2026-05-04. */
(function () {
  'use strict';

  var STORAGE_KEY = 'bai_consent_v1';

  function readChoice() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
    catch (e) { return null; }
  }
  function saveChoice(value) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (e) {}
  }

  function applyToShopify(consent) {
    // Best-effort: Shopify exposes window.Shopify.customerPrivacy on some shops.
    try {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.sale_of_data
        }, function () {});
      }
    } catch (e) { /* swallow */ }
  }

  // ---- GPC honoring -------------------------------------------------------
  // If user's browser sends Global Privacy Control, treat as opt-out of
  // sale/share + targeted advertising. Required to honor under CPRA reg.
  var gpc = (navigator.globalPrivacyControl === true);
  if (gpc) {
    var optOut = {
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
      source: 'gpc'
    };
    saveChoice(optOut);
    applyToShopify(optOut);
  }

  // ---- Banner -------------------------------------------------------------
  function showBanner() {
    if (document.getElementById('bai-consent-banner')) return;
    var existing = readChoice();
    if (existing) { applyToShopify(existing); return; }
    if (gpc) return; // already honored

    var b = document.createElement('div');
    b.id = 'bai-consent-banner';
    b.setAttribute('role', 'region');
    b.setAttribute('aria-label', 'Cookie and tracking consent');
    b.setAttribute('data-show', '1');
    b.innerHTML =
      '<p><strong>Your privacy.</strong> We use cookies and similar technologies for site functionality, analytics, and (with your permission) advertising. ' +
      'You can opt out of sale or sharing of your personal information at any time. ' +
      'See our <a href="/policies/privacy-policy">Privacy Policy</a> and <a href="/pages/ccpa-opt-out">Do Not Sell or Share My Personal Information</a>.</p>' +
      '<div class="bai-consent-actions">' +
        '<button type="button" data-action="accept">Accept all</button>' +
        '<button type="button" data-action="essential">Essential only</button>' +
        '<button type="button" data-action="optout">Opt out of sale/share</button>' +
      '</div>';
    document.body.appendChild(b);

    b.addEventListener('click', function (e) {
      var act = e.target && e.target.getAttribute && e.target.getAttribute('data-action');
      if (!act) return;
      var consent = (act === 'accept')
        ? { analytics: true, marketing: true, preferences: true, sale_of_data: true, source: 'accept' }
        : (act === 'essential')
        ? { analytics: false, marketing: false, preferences: false, sale_of_data: false, source: 'essential' }
        : { analytics: false, marketing: false, preferences: false, sale_of_data: false, source: 'optout' };
      saveChoice(consent);
      applyToShopify(consent);
      b.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showBanner);
  } else {
    showBanner();
  }

  // Expose a tiny API used by the /pages/ccpa-opt-out page.
  window.BeachAIPrivacy = {
    optOut: function () {
      var c = { analytics: false, marketing: false, preferences: false, sale_of_data: false, source: 'page-opt-out' };
      saveChoice(c); applyToShopify(c);
      return true;
    },
    accept: function () {
      var c = { analytics: true, marketing: true, preferences: true, sale_of_data: true, source: 'page-accept' };
      saveChoice(c); applyToShopify(c);
      return true;
    },
    status: function () { return readChoice(); }
  };
})();
